import { useEffect, useState } from "react";
import { Link, useLocation } from "react-router-dom";
import { ChatPanel } from "./ChatPanel";

const SESSION_KEY = "mc.ai.activeConversationId";

export function ChatWidget({ enabled }: { enabled: boolean }) {
  const [open, setOpen] = useState(false);
  const [conversationId, setConversationId] = useState<string | null>(
    () => sessionStorage.getItem(SESSION_KEY),
  );
  const location = useLocation();

  // Persist active conversation across navigations
  useEffect(() => {
    if (conversationId) sessionStorage.setItem(SESSION_KEY, conversationId);
  }, [conversationId]);

  // Hide on auth pages
  if (!enabled) return null;
  if (location.pathname === "/login" || location.pathname === "/reset-password") return null;
  // Also hide on the dedicated full-page version
  if (location.pathname.endsWith("/asistent")) return null;

  return (
    <div className={`chat-widget ${open ? "is-open" : ""}`}>
      {open ? (
        <div className="chat-widget-frame">
          <div className="chat-widget-header">
            <strong>Asistent</strong>
            <div className="chat-widget-header-actions">
              <Link
                to={location.pathname.startsWith("/admin") ? "/admin/asistent" : "/student/asistent"}
                className="chat-widget-icon"
                title="Deschide în pagină completă"
              >
                <i className="fa-solid fa-up-right-from-square" />
              </Link>
              <button
                className="chat-widget-icon"
                onClick={() => setOpen(false)}
                title="Închide"
              >
                <i className="fa-solid fa-xmark" />
              </button>
            </div>
          </div>
          <ChatPanel
            conversationId={conversationId}
            onConversationChange={setConversationId}
            variant="panel"
          />
        </div>
      ) : (
        <button
          className="chat-widget-fab"
          onClick={() => setOpen(true)}
          title="Asistent virtual"
        >
          <i className="fa-solid fa-comment-dots" />
          <span>Asistent</span>
        </button>
      )}
    </div>
  );
}
